import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CustomInput,
  Form,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row } from 'reactstrap';

class PersonifyDeclineStart extends Component {
  state = {
    modal: false,
    agreeChecked: false
  }

  handleModal = (e) => {
    e.preventDefault();
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  handleCheck = () => {
    this.setState({ agreeChecked: !this.state.agreeChecked });
  }

  handleCheckBtn = () => {
    this.setState({
      agreeChecked: true,
      modal: false
    });
    window.scrollTo(0,document.body.scrollHeight);
  }

  render() {
    const { modal, agreeChecked } = this.state;

    return (
      <div className="page-personify">
        <Container>

          <Row className="mb-3 mt-4">
            <Col xs={12} md={9} lg={5} className="text-center ml-auto mr-auto">
              <h3 className="ml-auto mr-auto mb-2">Unfortunately, LendingUSA is unable to approve your application for a loan</h3>
              <p className="mb-1">An adverse action notice will be sent within 30 days as to why we were unable to approve your application through Cross River Bank.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={9} lg={5} className="text-center ml-auto mr-auto mb-5">
              <h2 className="mb-4 cta-arrows"><u>But wait!</u> You might still qualify:</h2>
              <Card color="primary">
                <Form>
                  <CardBody>
                    <h4 className="mb-3 mt-1 text-white">We have teamed up with one of our lending partners, Personify Financial* who may still be able to offer you a loan.</h4>
                    <p className="mb-3 mt-1 text-white">Find out if you are approved in a few simple steps!</p>
                    <img src="/images/personify-logo.png" alt="Personify Financial" width="246" className="mb-3" />
                    <FormGroup className="mb-3">
                      <CustomInput type="checkbox" id="disclosuresCheckbox" label="I've read and agree to" className="mr-0 text-white" inline checked={agreeChecked} />
                      <a href="/" onClick={this.handleModal} className="text-white">&nbsp;<u>Personify’s Disclosures</u></a>
                    </FormGroup>
                    <Button tag={Link} to="/personify/consent" color="personify" className="w-100" disabled={!agreeChecked}>Yes, Continue</Button>
                  </CardBody>
                </Form>
              </Card>
              <Link to="/dashboard" className="text-secondary">No thank you, I'm not interested</Link>
            </Col>
          </Row>

        </Container>

        <Modal isOpen={modal} toggle={this.handleModal} size="lg" className="modal-personify">
          <ModalHeader toggle={this.handleModal}>Personify Financial Disclosure</ModalHeader>
          <ModalBody>
            <p>*Applied Data Finance DBA Personify Financial (“Personify”) offers personal consumer loans (“Loans”) ranging from $1,000 to $10,000 through its strategic lending partner, First Electronic Bank (“Lender”), an FDIC insured Utah state chartered industrial bank. <u style={{'textDecorationColor': 'red'}}>The APR’s on these loans range from 37.00% APR to 99.99% APR.</u></p>
            <p>By clicking ‘Yes, Continue’, you consent for us to share your personally identifiable information with Personify and its Lender. By clicking ‘Yes, Continue’ you also agree that you have read this disclaimer, understand it, and agree to be bound by it.  Upon clicking ‘Yes, Continue’ you and the data that you provided in your LendingUSA application will be forwarded to Personify and its Lender. Your use of the products, or services provided to you by Personify and/or its Lender will be subject to their terms and conditions, terms of use, and privacy policies and you should carefully review them.</p>
            <p>If you decide to purchase a product or service from Personify and/or its Lender, that transaction, and the use of those products and services will be between you, Personify, and its Lender. LendingUSA and Cross River Bank are not parties to your financial transaction with Personify and its Lenders. LendingUSA and Cross River Bank do not assume any responsibility or liability for the actions or representations of Personify, its Lenders, its affiliates or other third parties. LendingUSA provides you with access to Personify as a convenience, however, if your Loan application is approved by Personify and subsequently funded, we may receive compensation from Personify in connection with this transaction.</p>
            <p>By providing your number(s) to us, you are expressly consenting to receiving communications, including, but not limited to, prerecorded or artificial voice message calls, text messages, and calls made by an automatic telephone dialing system, from your lender, or any of its affiliates, service providers, assignees, or agents, at the phone number(s) you provided for servicing and collection purposes related to any loan that you may obtain from the lender.</p>
          </ModalBody>
          <ModalFooter>
            <Button color="personify" onClick={this.handleCheckBtn} className="ml-auto mr-auto">I Understand &amp; Agree</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default PersonifyDeclineStart;
